/* Is the site running inside our Android app (October 2026)? The Play Store app is a
   Trusted Web Activity: it opens https://sramika.com/?source=twa in Chrome, and Chrome
   reports the app as the referrer. Once seen, the answer is remembered on this phone, so
   later pages (and visits) know too. No imports, so the tests load it as it is. */

const KEY = "sramika_shell";
export const ANDROID_PACKAGE = "com.sramika.app";

/* Wallet top-ups inside the Android app (decision D): hidden for the first Play release.
   Turning them on is this line and a website deploy - no app update. */
export const ANDROID_APP_TOP_UPS = false;

export function detectShell(loc = typeof window !== "undefined" ? window.location : null, doc = typeof document !== "undefined" ? document : null) {
  try {
    const fromApp = new URLSearchParams(loc?.search || "").get("source") === "twa"
      || String(doc?.referrer || "").startsWith(`android-app://${ANDROID_PACKAGE}`);
    if (fromApp) localStorage.setItem(KEY, "android-app");
  } catch { /* storage blocked: the page still works, as on the web */ }
}

export function inAndroidApp() {
  try { return localStorage.getItem(KEY) === "android-app"; } catch { return false; }
}
